import React, { useEffect, useState ,useRef} from "react";

import classes from "./Chatbox.module.css";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import LoadingButton from "@mui/lab/LoadingButton";
import { generateAudio } from "../../constant/Api";

const Chatbox = ({ setLink, data,currentAudio, setCurrentAudio ,selectedItem, setSelectedItem}) => {
  const [isLoading, setIsLoading] = useState(false);
  const selectedItemRef = useRef(null);
  useEffect(() => {
    if (selectedItemRef.current) {
      selectedItemRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [selectedItem]);
  const generate = async (Prompt, id) => {
    // Stop the current audio if it exists
    if (currentAudio && !currentAudio?.paused && id === selectedItem) {
      currentAudio.pause();
      setCurrentAudio(null);
      return;
    }
    if (currentAudio) {
      currentAudio.pause();
      setCurrentAudio(null);
    }
    setIsLoading(true);
    const url = await generateAudio(Prompt);
    setIsLoading(false);
    const audio = new Audio(url);
    audio.play();
    setCurrentAudio(audio); // Set the current audio element
    setSelectedItem(id);
  };
  return (
    <div className={classes.main}>
      <div className={classes.box}>
        <div className={classes.container}>
          {data &&
            data.map((el, i) => (
              <div key={i} ref={el.id === selectedItem ? selectedItemRef : null}>
                <div className={classes.question}>
                  <h3>You:</h3>
                  <p>{el.input}</p>
                </div>
                <div className={classes.answer}>
                  <div className={classes.flexContainer}>
                    <div className={classes.flexAnswer}>
                      <h3>Luke:</h3>
                      <p>{el.Prompt}</p>
                    </div>
                    <div className={classes.flexButton}>
                      <div>
                        <LoadingButton
                          onClick={() => generate(el.Prompt, el.id)}
                          loading={isLoading && el.id === selectedItem}
                          variant="outlined"
                        >
                          <span>
                            {currentAudio &&
                            !currentAudio?.paused &&
                            el.id === selectedItem
                              ? "Pause"
                              : "Play"}
                          </span>
                        </LoadingButton>
                      </div>
                      <div className="mt6">
                        <Button variant="outlined" onClick={() => setLink(el)}>
                          {el.link === "" ? "Generate" : "Video"}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Chatbox;
